import PropTypes from 'prop-types';

/**
 * Holds its children back until the supported Locales have loaded, so that no
 * course content can be queried before the Locale to request it in is known.
 *
 * Renders no markup of its own - the Locale itself lives on contentLocaleStore,
 * which the Apollo link and the picker read directly.
 */
export const ContentLocaleProvider = ({ contentLocalesResource, children }) => {
  contentLocalesResource.read();

  return children;
};

ContentLocaleProvider.propTypes = {
  contentLocalesResource: PropTypes.shape({ read: PropTypes.func }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
